const PDF_PUBLIC_ASSET_ROOT = 'ember-simplepractice/pdfjs';

export function webpackPublicPath() {
  // Webpack replaces this identifier with the runtime public path (CDN +
  // PUBLIC_ASSET_PREFIX). Keep it as a bare identifier so the replacement
  // still happens after Rollup emits this file.
  // eslint-disable-next-line camelcase, no-undef
  return typeof __webpack_public_path__ === 'string' ? __webpack_public_path__ : '';
}

export function publicAssetBaseUrl(publicPath = webpackPublicPath()) {
  let origin = `${globalThis.location?.origin ?? ''}/`;
  let base;

  if (!publicPath || publicPath === 'auto') {
    base = origin;
  } else if (/^(https?:)?\/\//.test(publicPath)) {
    base = publicPath.endsWith('/') ? publicPath : `${publicPath}/`;
  } else {
    base = new URL(publicPath, origin).href;
  }

  // Webpack's public path is the JS/CSS `assets/` directory. v2 addon
  // `public-assets` are copied to app-root URLs (`/ember-simplepractice/pdfjs/...`),
  // next to `assets/`, so drop a trailing `assets/` segment.
  return base.replace(/assets\/$/, '');
}

export function pdfRuntimeAssetUrl(directory, publicPath) {
  let assetPath = `${PDF_PUBLIC_ASSET_ROOT}/${directory}/`;

  try {
    return new URL(assetPath, publicAssetBaseUrl(publicPath)).href;
  } catch {
    return `${globalThis.location?.origin ?? ''}/${assetPath}`;
  }
}

export function pdfRuntimeFileUrl(directory, fileName, publicPath) {
  try {
    return new URL(fileName, pdfRuntimeAssetUrl(directory, publicPath)).href;
  } catch {
    return `${pdfRuntimeAssetUrl(directory, publicPath)}${fileName}`;
  }
}
